import React from 'react';

interface LogoLinkProps {
  href: string;
  brandName: string;
  logoSrc: string;
  logoHeight: string;
}

export default function LogoLink({ href, brandName, logoSrc, logoHeight }: LogoLinkProps) {
  return (
    <a className="py-2" href={href}>
      <span className="sr-only">{brandName}</span>
      <img className={`${logoHeight} w-auto`} src={logoSrc} alt={brandName} />
    </a>
  );
}
